// @material-ui
import { makeStyles } from '@material-ui/styles'

export const fileInputStyle = theme => ({
  root: {},
  helperTextWrap: {},
})

export const useFileInputStyle = makeStyles(fileInputStyle)
